import {reactive} from '@/plugins/compositionApi'

const demoSourceId = -134681298

const app = reactive({
  resolved: true,
  inVk: false,
  inWeb: false,
  inOrgSite: false,
  isAdmin: false,
  isContextless: false,
  isDesktop: false,
  isMobile: false,
  isMobileAndroid: false,
  isMobileWeb: false,
  messagesDisabled: false,
  messagesRejected: false,
  showLoginButton: true,
  snackbarMessage: null,
  sourceId: null,
  sourceIsDemo: false,
  buyoutId: null,
  storeUrl: null,
  tokenRejected: false
})

let checkWorkabilityFn;
const checkSourceIsDemo = (sourceId) => sourceId === demoSourceId
const getResolved = () => app.resolved
const getInOrgSite = () => app.inOrgSite
const getInVk = () => app.inVk
const getInWeb = () => app.inWeb
const getShowLoginButton = () => app.showLoginButton
const getIsVkApp = () => getInVk() && !app.isContextless
const getIsVkAppContextless = () => getInVk() && app.isContextless
const getIsVkAppAdmin = () => getInVk() && app.isAdmin
const getIsVkAppDesktop = () =>  getInVk() && app.isDesktop
const getIsVkAppMobile = () =>  getInVk() && app.isMobile
const getIsVkAppMobileAndroid = () =>  getInVk() && app.isMobileAndroid
const getMessagesDisabled = () => app.messagesDisabled
const getMessagesRejected = () => app.messagesRejected
const getSnackbarMessage = () => app.snackbarMessage
const getSourceId = () => app.sourceId
const getSourceIsDemo = () => app.sourceIsDemo
const getBuyoutId = () => app.buyoutId
const getStoreUrl = () => app.storeUrl
const getTokenRejected = () => app.tokenRejected

const setAppInitiator = vkData => {
  if (vkData) {
    app.inVk = true
    app.isAdmin = vkData.vk_viewer_group_role === 'admin'
    app.isDesktop = vkData.vk_platform.startsWith('desktop')
    app.isMobile = vkData.vk_platform.startsWith('mobile')
    app.isMobileAndroid = vkData.vk_platform.startsWith('mobile_android')
    app.isMobileWeb = vkData.vk_platform === 'mobile_web'
    app.isContextless = !vkData.source_id
  } else {
    app.inWeb = true
  }
}

const setCheckWorkabilityFn = fn => {
  checkWorkabilityFn = fn;
}

const setMessagesDisabled = disabled => {
  app.messagesDisabled = disabled
}

const setMessagesRejected = rejected => {
  app.messagesRejected = rejected
}

const setOrgSite = sourceId => {
  app.sourceId = sourceId
  app.inOrgSite = true
}

const setResolved = resolved => {
  app.resolved = resolved
}

const setShowLoginButton = show => {
  app.showLoginButton = show
}

const setSnackbarMessage = message => {
  app.snackbarMessage = message
}

const setSource = (sourceId, adminLevel) => {
  const castedSourceId = +sourceId
  if (castedSourceId !== app.sourceId) {
    app.sourceId = castedSourceId
    app.sourceIsDemo = app.sourceId === demoSourceId
    if (adminLevel > -1) {
      app.isAdmin = +adminLevel === 3
    }
    if (checkWorkabilityFn) {
      checkWorkabilityFn(app.sourceId)
    }
  }
}

const setBuyoutId = buyoutId => app.buyoutId = buyoutId

const setStoreUrl = url => app.storeUrl = url

const setTokenRejected = rejected => app.tokenRejected = rejected

export {
  checkSourceIsDemo,
  getResolved,
  setResolved,
  getInOrgSite,
  getInVk,
  getInWeb,
  getIsVkApp,
  getIsVkAppAdmin,
  getIsVkAppContextless,
  getIsVkAppDesktop,
  getIsVkAppMobile,
  getIsVkAppMobileAndroid,
  getShowLoginButton,
  setAppInitiator,
  setCheckWorkabilityFn,
  getMessagesDisabled,
  setMessagesDisabled,
  getMessagesRejected,
  setMessagesRejected,
  setOrgSite,
  setShowLoginButton,
  getSnackbarMessage,
  setSnackbarMessage,
  getSourceId,
  setSource,
  getSourceIsDemo,
  getBuyoutId,
  setBuyoutId,
  getStoreUrl,
  setStoreUrl,
  getTokenRejected,
  setTokenRejected
}